// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.support.RentalManagerGuestSupportWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GuestSupportGetHelpTopicsResponseWebDto,
  GuestSupportSubmitRequestWebDto,
  RentalManagerSupportHelpArticlesResponseDto,
} from '../..';

interface GetHelpArticlesParams {
  category?: string;
  topic?: string;
}

export const RentalManagerGuestSupportWebApiHandler_getHelpArticles_Path = '/api/web/v1/support/getHelpArticles';

/**
 * Get help articles
 */
export const RentalManagerGuestSupportWebApiHandler_getHelpArticles = (
  getParams: GetHelpArticlesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetHelpArticlesParams, never, RentalManagerSupportHelpArticlesResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerGuestSupportWebApiHandler_getHelpArticles_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerGuestSupportWebApiHandler_getHelpTopics_Path = '/api/web/v1/support/getHelpTopics';

export const RentalManagerGuestSupportWebApiHandler_getHelpTopics = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GuestSupportGetHelpTopicsResponseWebDto>(
    {
      endpoint: RentalManagerGuestSupportWebApiHandler_getHelpTopics_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerGuestSupportWebApiHandler_submitRequest_Path = '/api/web/v1/support/submitRequest';

/**
 * Submit a support request
 */
export const RentalManagerGuestSupportWebApiHandler_submitRequest = (
  postData: GuestSupportSubmitRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GuestSupportSubmitRequestWebDto, string>(
    {
      endpoint: RentalManagerGuestSupportWebApiHandler_submitRequest_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
